<template>
    <MainContentSearchable title="Listado de equipos" id="equipos" v-model="filters" :meta="loading ? {} : equipos.meta" @updated="debouncedGetEquipos">
        <template v-slot:header>
            <div class="mb-3">
                <router-link :to="{ name: 'back.bases.equipos.crear', params: { lista_id: lista_id } }" class="btn btn-primary mr-2" target="blank">Crear</router-link>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="!loading" :class="['table', { 'expanded': equipos.data.length <= 3 }]">
                <b-table hover :items="equipos.data" :fields="fields" id="equipos-table">
                    <template #cell(representante)="{ item }">
                        {{ item.representante ? item.representante.name : '' }}
                    </template>
                    <template #cell(edad_media)="{ item }">
                        {{ item.edad_media ? item.edad_media + ' años' : '' }}
                    </template>
                    <template #cell(imagen)="{ item }">
                        <img :src="item.imagen_formatted" style="width: 75px;"/>
                    </template>
                    <template #cell(opciones)="{ item, index }">
                        <OpcionesDropdownTableComponent 
                            :lastIndex="equipos.data.length > 3 && index >= equipos.data.length - 3"
                            v-bind:options="[
                                { to: { name: 'back.bases.equipos.show', params: { lista_id: lista_id, equipo_id: item.id } }, label: 'Detalle'},
                                { to: { name: 'back.bases.equipos.update', params: { lista_id: lista_id, equipo_id: item.id } }, label: 'Editar'},
                                { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'},
                            ]"
                        />
                        <BorrarModalComponent
                            :name="'borrar-' + item.id"
                            :title="'Borrar equipos ' + item.nombre"
                            confirmButton="¿Está segur@ de borrar este equipo?"
                            v-on:close="() => closeModal()"
                            v-on:confirm="() => borrar(item.id)"
                        />
                    </template>
                </b-table>
            </div>
            <LoaderComponent v-else/>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent"

    export default {
        data() {
            return {
                equipos: { data: [], meta: { current_page: 1 } },
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "id", label: "ID"},
                    { key: "nombre", label: "Nombre" },
                    { key: "representante", label: "Representante" },
                    { key: "imagen", label: "Imagen", class: 'text-center' },
                    { key: "edad_media", label: "Edad media", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
            }
        },
        created() {
            this.getEquipos();
            this.debouncedGetEquipos = _.debounce(this.getEquipos, 500);
        },
        methods: {
            getEquipos() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    filters: this.filters
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.equipos.index'), params).then(res => {
                    this.equipos = res.data;
                }).finally(() => this.loading = false);
            },
            borrar(equipo_id) {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    equipo_id: equipo_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.equipos.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.getEquipos();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, BorrarModalComponent
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>